import React from 'react';
import styles from '../Operations.module.css';

interface HRASComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * HRAS - Helpful Ready by Associate
 * KPI information component
 */
const HRAS: HRASComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        Helpful Ready is the foundational knowledge needed to deliver on Ace’s brand promise. 
        <br /><br />
        The Helpful Ready Assessment is the last step in an associate’s onboarding, and an associate must receive an 80% or higher on the assessment to be Helpful Ready. 
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
       Customer-facing associates are designated by you in Ace Learning Place (ALP). Each role that has the customer-facing field selected in ALP will count toward the Helpful Ready and Product Knowledge Badge calculations. If you have 10 associates in Ace Learning Place, and 8 are customer-facing, when calculating the Helpful Ready percentage, it would be the number that has successfully passed divided by the 8 customer-facing associates.
        <br /><br />
        Once an associate becomes Helpful Ready, they do not need to retake the Helpful Ready Assessment annually.
      </div>

       <div className={styles.sectionTitle}>
       Goal
      </div>
      <div className={styles.sectionContent}>
        <strong>Pinnacle:</strong> 75% of customer-facing associates are Helpful Ready & 16 Product Knowledge Badges earned.
        <br /><br />
         <strong>Platinum:</strong> 50% of customer-facing associates are Helpful Ready & 8 Product Knowledge Badges earned.
      </div>


      <div className={styles.sectionTitle}>
        Drill Down
      </div>
      <div className={styles.sectionContent}>
       Clicking your score will open up a grid of active users for your store and their Helpful Ready completions and each individual users Training Hours.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        See Ace Way of Retailing (AWOR){' '}
        <a
          href="https://acenet.aceservices.com/awor/helpful-customer-service/customer-first-culture"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          https://acenet.aceservices.com/awor/helpful-customer-service/customer-first-culture
        </a>{' '}
        or go to Ace Learning Place and search Helpful Ready for more information.
      </div>
    </div>
  );
};

HRAS.title = 'Helpful Ready';
HRAS.actionTitle = 'Helpful Ready By Associate';
HRAS.actionHyperlink = 'dynamicURL:WFC:current';
export default HRAS;
